import { render, staticRenderFns } from "./NavigationIcon.vue?vue&type=template&id=98060602&scoped=true&"
import script from "./NavigationIcon.vue?vue&type=script&lang=js&"
export * from "./NavigationIcon.vue?vue&type=script&lang=js&"
import style0 from "./NavigationIcon.vue?vue&type=style&index=0&id=98060602&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98060602",
  null
  
)

export default component.exports